import {
    DateAdapter as CalendarDateAdapter,
    CalendarMomentDateFormatter,
    CalendarDateFormatter,
    CalendarModule,
    MOMENT,
} from 'angular-calendar';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {enableProdMode, LOCALE_ID, DEFAULT_CURRENCY_CODE, importProvidersFrom} from '@angular/core';
import {HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient} from '@angular/common/http';
import {BrowserModule, bootstrapApplication} from '@angular/platform-browser';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {provideAnimations} from '@angular/platform-browser/animations';
import {MAT_TOOLTIP_DEFAULT_OPTIONS} from '@angular/material/tooltip';
import {adapterFactory} from 'angular-calendar/date-adapters/moment';
import {DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
// import {MatCarouselModule} from '@thouet/material-carousel';
import localeDeExtra from '@angular/common/locales/extra/de';
import {AuthInterceptor, BASE_PATH} from 'kkm-library';
import {registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {LightboxModule} from 'ngx-lightbox';
import {LinkyModule} from 'ngx-linky';
import moment from 'moment';

import {AppRoutingModule} from './app/app-routing.module';
import {environment} from './environments/environment';
import {AppComponent} from './app/app.component';

export function momentAdapterFactory() {
    return adapterFactory(moment);
}

if (environment.production) {
    enableProdMode();
}

registerLocaleData(localeDe, localeDeExtra);

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            FormsModule,
            ReactiveFormsModule,
            AppRoutingModule,
            // MatCarouselModule,
            CalendarModule.forRoot(
                {
                    provide: CalendarDateAdapter,
                    useFactory: momentAdapterFactory,
                },
                {
                    dateFormatter: {
                        provide: CalendarDateFormatter,
                        useClass: CalendarMomentDateFormatter,
                    },
                },
            ),
            LinkyModule,
            LightboxModule,
        ),
        {
            provide: MOMENT,
            useValue: moment,
        },

        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},

        // provideMomentDateAdapter(),
        {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
        {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}},
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        {provide: LOCALE_ID, useValue: 'de-DE'},
        {provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'},
        {provide: BASE_PATH, useValue: environment.basePath},
        {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}},
        {provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: {showDelay: 500, hideDelay: 1000}},
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
    ],
}).catch(err => console.error(err));
